import { InfluencerNote } from '../../../../models/influencer-note';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { InlineEditNoteComponent } from '../inline-edit-note/inline-edit-note.component';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../../services/modal/modal.service';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { CacheService } from '../../../services/cache/cache.service';
import { DateUtils } from '../../../utils/date.utils';
import { UserService } from '../../../services/user.service';
import { ObjectUtils } from '../../../utils/object.utils';
var AddNotesComponent = /** @class */ (function () {
    function AddNotesComponent(influencerService, modalService, cacheService, translate, userService) {
        this.influencerService = influencerService;
        this.modalService = modalService;
        this.cacheService = cacheService;
        this.translate = translate;
        this.userService = userService;
        this.FAKE_NEW_NOTE_ID = 99999;
        this.allowToAddNewNote = true;
        this.newNote = new InfluencerNote();
        this.notes = [];
        this.previousNotes = [];
        this.sampleNote = {
            id: 0,
            userId: 0,
            userName: this.translate.instant('note.sample_user'),
            companyId: 0,
            influencerId: 0,
            content: this.translate.instant('note.sample_content')
        };
        this.isFetchingNotes = false;
        this.isAddedNoteBefore = false;
    }
    AddNotesComponent.prototype.ngOnInit = function () {
        this.loadListNote(this.influencerId);
        this.newNote.influencerId = this.influencerId;
        this.getCurrentUserInfo();
    };
    AddNotesComponent.prototype.getCurrentUserInfo = function () {
        var _this = this;
        this.userService.getCurrentUserInfo().subscribe(function (res) {
            if (res && res.data) {
                _this.currentUserInfo = res.data;
            }
        });
    };
    AddNotesComponent.prototype.loadListNote = function (influencerId) {
        var _this = this;
        this.isFetchingNotes = true;
        this.cacheService.get("influencer_notes_" + this.influencerId, this.influencerService.loadNoteListOfInfluencer(influencerId)).subscribe(function (res) {
            _this.isFetchingNotes = false;
            if (res && res.data) {
                _this.notes = res.data.noteList;
                _this.previousNotes = ObjectUtils.deepClone(_this.notes);
                _this.isAddedNoteBefore = res.data.haveAddedNote;
            }
        });
    };
    AddNotesComponent.prototype.afterCreateOrUpdateNote = function (evt) {
        var _this = this;
        if (!evt.note) {
            return;
        }
        var noteData = {
            id: evt.note.id ? evt.note.id : null,
            userId: evt.note.userId,
            userName: evt.note.userName ? evt.note.userName : this.currentUserInfo.fullName,
            companyId: evt.note.companyId ? evt.note.companyId : this.currentUserInfo.company.id,
            influencerId: evt.note.influencerId ? evt.note.influencerId : this.influencerId,
            content: evt.note.content,
            createdAt: DateUtils.now(),
            modifiedAt: DateUtils.now(),
        };
        if (evt.isCreated) {
            // add faked id for new Note to show in UI immediately (Optimistic UI)
            var newAddedNote = Object.assign({}, noteData, {
                id: this.FAKE_NEW_NOTE_ID
            });
            this.notes.push(newAddedNote);
        }
        this.allowToAddNewNote = true;
        this.newNote.content = undefined;
        this.cacheService.clear("influencer_notes_" + this.influencerId);
        this.influencerService.createOrUpdateNote(noteData).subscribe(function (res) {
            _this.loadListNote(_this.influencerId);
        }, function (err) {
            _this.notes = _this.previousNotes;
            _this.onErrorHappen(evt);
        });
    };
    AddNotesComponent.prototype.onErrorHappen = function (evt) {
        this.modalService.open(this.notificationNoteErrorProcessing, null, true);
    };
    AddNotesComponent.prototype.afterDeleteNote = function (evt) {
        this.loadListNote(this.influencerId);
    };
    AddNotesComponent.prototype.onAddNewNote = function () {
        var _this = this;
        this.allowToAddNewNote = false;
        setTimeout(function () {
            _this.createNewNoteRef.contextBox.nativeElement.focus();
        }, 200);
    };
    AddNotesComponent.prototype.cancelAddingNote = function () {
        this.allowToAddNewNote = true;
    };
    AddNotesComponent.prototype.closeNotification = function () {
        this.modalService.close();
    };
    Object.defineProperty(AddNotesComponent.prototype, "showSuggestion", {
        get: function () {
            return !this.isFetchingNotes && !this.isAddedNoteBefore;
        },
        enumerable: true,
        configurable: true
    });
    AddNotesComponent.prototype.deletedNote = function (evt) {
        var _this = this;
        this.notes = this.notes.filter(function (noteItem) { return noteItem.id !== evt; });
        this.cacheService.clear("influencer_notes_" + this.influencerId);
        this.influencerService.deleteNote(evt).subscribe(function (res) {
            _this.loadListNote(_this.influencerId);
        }, function (err) {
            _this.notes = _this.previousNotes;
            _this.onErrorHappen(evt);
        });
    };
    return AddNotesComponent;
}());
export { AddNotesComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/add-notes/add-notes.component.ts.pre-build-optimizer.js